var _style, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhy01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 417 414",
    width: 417,
    height: 414,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "why-01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #000000 } \n\t\t.s1 { fill: #ffb600 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m272.2 271.8c5 5.3 4.8 14.6-1.3 19.1-11.4 8.4-45.6 4.2-59.1 0.7-5.6-1.5-17.9-8.6-20.9-1.6-3.8 8.7 7 11.2 13.1 13.1 45.1 13.8 77.1 2.4 116.2-19.3 15.7-8.7 31.2-20.5 46.9-28.4 7.5-3.7 18.1-6.9 23.7 1.7 7.9 12.1-8.5 23.4-16.9 29.5-25.6 18.7-77.2 50.3-107.5 56.8-46.5 10-96.2-12.3-141.1 7l-60.5-60.2c11.4-12.7 23.5-27.1 37.3-37.3 45-33.1 74 0.9 119.6 10.5 15.1 3.2 28.2 2.4 42.8 4.4 2.4 0.3 6.1 2.2 7.7 4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m182 118.6c-11.4 58.8 38.3 110.1 97.6 101.1 33.3-5.1 62-31.7 69.5-64.4 17.9-77.7-68-135.3-132.9-90 0.8-11.4-6.2-21.3-18.3-20.5l5.4-4.1c58.8-38.9 138.8-15 166.5 49.5 37.4 86.9-41.6 177.9-133.1 154.3-60.9-15.7-97.7-81-79.3-141.6-0.2-1.1-15-9.5-17.2-11.4-4.1-3.5-3.1-7.4 1.2-10 16.1-9.8 38.7-15.8 55.3-25.4 5.3-2.2 8.9 1.2 8.9 6.5l-0.4 62.9c-3.7 10-21.3-8.3-23.2-6.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m45.6 296c2.8-0.2 6.2 0.8 8.5 2.5l63.3 63.8c6.4 13.1-13.6 23.6-20.3 32.5l-77.2-77.2c7-5.4 16.7-20.7 25.7-21.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m255 146.7l1.9-0.7 47.6-47.5c9.8-9.6 24.5 2.5 16.7 13.6l-60.1 60.1c-4.4 4-11.3 3.6-15.5-0.4-6.5-11.9-15.4-23.9-21.2-36-2.2-4.5-3.4-7.4-0.8-12.4 3-5.6 12.1-6.6 16.6-2.5 3.2 2.9 10.4 17.4 13.4 22.3 0.7 1.1 1.3 2.3 1.4 3.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhy01);
export default __webpack_public_path__ + "static/media/why-01.2b8cb35e3f9d9dd9f7ab59779a6bf2ca.svg";
export { ForwardRef as ReactComponent };